import { Config } from '../config';
import { ACLResource } from '../Store/ResourcesManagement/Types';
import { UserACL } from '../Store/UserManagement/Types';
import {
	StatusCodeFilter /*, StatusCodeError, StatusCodeFilterAxios*/,
} from './StatusCodeError';
//import   { Logger } from '../Utils/Logger';
import { IAuthSuccess, IContentDisposition, IGetUserSuccess } from './Types';

export type BackendMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
export class Backend {
	public static getInstance() {
		if (!Backend.instance) {
			Backend.instance = new Backend();
		}
		return Backend.instance;
	}

	private static instance: Backend;
	private token: string = '';
	private resultUser: UserACL[] = [];

	public setToken(tok: string) {
		this.token = tok;
	}

	public setResultUser(resUse: UserACL[]) {
		this.resultUser = resUse;
	}

	isGetUserSuccess(object: any): object is IGetUserSuccess {
		return 'resultUser' in object && typeof object.result === 'object';
	}

	isAuthSuccess(object: any): object is IAuthSuccess {
		return 'token' in object && typeof object.token === 'string';
	}

	private async callBackend(
		route: string,
		method: BackendMethod = 'GET',
		body: ArrayBuffer | FormData | null = null,
		addHeaders: Headers | null = null
	): Promise<ArrayBuffer | IContentDisposition> {
		const url =
			route.length === 0 || route[0] !== '/'
				? `${Config.backendAPIURL}/${route}`
				: `${Config.backendAPIURL}${route}`;

		const headers =
			addHeaders === null
				? new Headers({
						'Content-Type': 'application/json',
						Accept: 'application/json',
				  })
				: addHeaders;

		return fetch(url, {
			body,
			cache: 'no-cache',
			headers,
			method,
			mode: 'cors',
			redirect: 'error',
		}).then(StatusCodeFilter);
	}

	private async callBackendNoStatusCodeFilter(
		route: string,
		method: BackendMethod = 'GET',
		body: ArrayBuffer | FormData | null = null,
		addHeaders: Headers | null = null
	): Promise<Response> {
		const url =
			route.length === 0 || route[0] !== '/'
				? `${Config.backendAPIURL}/${route}`
				: `${Config.backendAPIURL}${route}`;

		const headers =
			addHeaders === null
				? new Headers({
						'Content-Type': 'application/json',
						Accept: 'application/json',
				  })
				: addHeaders;
		return fetch(url, {
			body,
			cache: 'no-cache',
			credentials: 'include',
			headers,
			method,
			mode: 'cors',
			redirect: 'error',
		}).then((res: Response) => res);
	}

	private async callBackendJSON(
		route: string,
		obj: any,
		addHeaders: Headers | null = null
	): Promise<ArrayBuffer | IContentDisposition> {
		const data = this.obj2ab(obj);
		const headers = addHeaders === null ? new Headers() : addHeaders;

		headers.append('content-type', 'application/json');
		return this.callBackend(route, 'POST', data, headers);
	}

	public async addGroupChannels(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'ma/channels/group/' + groupID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async addGroupChannelsMT(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'mt/channels/group/' + groupID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async addUserChannels(channelList: number[], userID: number) {
		return this.callBackendNoStatusCodeFilter(
			'ma/channels/user/' + userID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async addGroupChannelsTPP(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'tpp/channels/group/' + groupID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async addUserChannelsTPP(channelList: number[], userID: number) {
		return this.callBackendNoStatusCodeFilter(
			'tpp/channels/user/' + userID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async addGroupChannelsSTT(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'stt/channels/group/' + groupID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async addUserChannelsSTT(channelList: number[], userID: number) {
		return this.callBackendNoStatusCodeFilter(
			'stt/channels/user/' + userID,
			'PATCH',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async addUserResourceRights(
		token: string,
		userId: number,
		resourceId: number,
		rightsIds: number[]
	) {
		return this.callBackendNoStatusCodeFilter(
			'addUserResourceRights',
			'POST',
			this.obj2ab({
				token,
				userId,
				resourceId,
				rightsIds,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async createACLUser(
		token: string,
		dateCreation: string,
		dateDebut: string,
		email: string,
		firstname: string,
		isActive: boolean,
		isGroup: boolean,
		name: string,
		parentID: number,
		password: string,
		username: string,
		phone: string,
		position: string,
		localisation: string[],
		language: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'createUser',
			'POST',
			this.obj2ab({
				token,
				dateCreation,
				dateDebut,
				email,
				firstname,
				isActive,
				isGroup,
				name,
				parentID,
				password,
				username,
				phone,
				position,
				localisation,
				language,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				if (res.status === 403) {
					throw new Error(
						'Error during the creation of the user. Please contact support'
					);
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async createMultipleACLUser(
		token: string,
		users: {
			dateCreation: string;
			dateCreationFormated: string;
			dateDebut: string;
			dateDebutFormated: string;
			email: string;
			firstname: string;
			isActive: boolean;
			isGroup: boolean;
			language: string;
			lastname: string;
			localisation: string[];
			parentID: number;
			parentName: string;
			password: string;
			phone: string;
			position: string;
			username: string;
		}[]
	) {
		return this.callBackendNoStatusCodeFilter(
			'createMultipleUsers',
			'POST',
			this.obj2ab({ token, users })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				if (res.status === 403) {
					throw new Error(
						'Error during the creation of the user. Please contact support'
					);
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async createResource(
		token: string,
		name: string,
		type: number,
		isparent: boolean,
		parentID?: number
	) {
		return this.callBackendNoStatusCodeFilter(
			'createResource',
			'POST',
			this.obj2ab({ token, name, type, isparent, parentID })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getUsers(token: string, rows: number, page: number) {
		return this.callBackendNoStatusCodeFilter(
			'getUsers',
			'POST',
			this.obj2ab({ token, rows, page })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					const returnedTarget = Object.assign(this.resultUser, res);
					this.resultUser = returnedTarget;
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLResource(token: string, id: number) {
		return this.callBackendNoStatusCodeFilter(
			'resource/' + id,
			'GET',
			null,
			new Headers({
				Authorization: 'Bearer ' + token,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLResourcesTypes(token: string) {
		return this.callBackendNoStatusCodeFilter(
			'getACLResourcesTypes',
			'POST',
			this.obj2ab({ token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLResourcesParents(token: string) {
		return this.callBackendNoStatusCodeFilter(
			'getACLResourcesParents',
			'POST',
			this.obj2ab({ token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLRights(token: string) {
		return this.callBackendNoStatusCodeFilter(
			'getACLRights',
			'POST',
			this.obj2ab({ token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLResources(token: string) {
		return this.callBackendNoStatusCodeFilter(
			'getACLResources',
			'POST',
			this.obj2ab({ token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLUserByID(token: string, id: number) {
		return this.callBackendNoStatusCodeFilter(
			'getACLUserByID',
			'POST',
			this.obj2ab({
				token,
				id,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getACLUsersResearch(
		token: string,
		rows: number,
		page: number,
		sortBy: string,
		sortDirection: string,
		researchField: string,
		isActive: boolean,
		isGroup: boolean,
		usersParentID: number
	) {
		return this.callBackendNoStatusCodeFilter(
			'getACLUsers',
			'POST',
			this.obj2ab({
				token,
				rows,
				page,
				sortBy,
				sortDirection,
				researchField,
				isActive,
				isGroup,
				usersParentID,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getAllMedias() {
		return this.callBackendNoStatusCodeFilter('getAllMedias', 'POST')
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getGroupsAndUsersFromChannel(
		mediaNumber: number,
		token: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'ma/channels/alloweds/' + mediaNumber + '/' + token,
			'GET'
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getChannelsFromUser(userID: number, group: boolean) {
		const url = group
			? 'ma/channels/group/' + userID
			: 'ma/channels/user/' + userID;
		return this.callBackendNoStatusCodeFilter(url, 'GET')
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getChannelsFromUserMT(userID: number, token: string) {
		const url = 'mt/channels/group/' + userID + '/' + token;
		console.log(url);
		return this.callBackendNoStatusCodeFilter(url, 'GET')
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getGroupsFromChannelMT(mediaNumber: number, token: string) {
		return this.callBackendNoStatusCodeFilter(
			'mt/channels/alloweds/' + mediaNumber + '/' + token,
			'GET'
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getGroupsAndUsersFromChannelTPP(
		mediaNumber: number,
		token: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'tpp/channels/alloweds/' + mediaNumber + '/' + token,
			'GET'
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getChannelsFromUserTPP(userID: number, group: boolean) {
		const url = group
			? 'tpp/channels/group/' + userID
			: 'tpp/channels/user/' + userID;
		return this.callBackendNoStatusCodeFilter(url, 'GET')
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getGroupsAndUsersFromChannelSTT(
		mediaNumber: number,
		token: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'stt/channels/alloweds/' + mediaNumber + '/' + token,
			'GET'
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async getChannelsFromUserSTT(userID: number, group: boolean) {
		const url = group
			? 'stt/channels/group/' + userID
			: 'stt/channels/user/' + userID;
		return this.callBackendNoStatusCodeFilter(url, 'GET')
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getMedia(mediaNumber: number) {
		return this.callBackendNoStatusCodeFilter(
			'getMedia',
			'POST',
			this.obj2ab({ mediaNumber })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getUserRights(token: string, id: number) {
		return this.callBackendNoStatusCodeFilter(
			'getUserRights',
			'POST',
			this.obj2ab({ token, id })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async login(username: string, password: string) {
		return this.callBackendNoStatusCodeFilter(
			'auth',
			'POST',
			this.obj2ab({ username, password })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (this.isAuthSuccess(res)) {
					this.token = res.token;
					return res;
					//return [res.token, res.expires * 1000, res.results];
				}

				throw new Error('Invalid response from backend');
			});
	}

	public async logout() {
		return this.callBackendJSON('/auth/logout', {})
			.then(this.ab2obj)
			.then((res: any) => {
				return res;
			});
	}

	public async modifyACLUserName(token: string, id: number, param: string) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserName',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserLanguage(
		token: string,
		id: number,
		param: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserLanguage',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserLocalisation(
		token: string,
		id: number,
		param: string[]
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserLocalisation',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserPosition(
		token: string,
		id: number,
		param: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserPosition',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserPhone(token: string, id: number, param: string) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserPhone',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserUsername(
		token: string,
		id: number,
		param: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserUsername',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserFirstname(
		token: string,
		id: number,
		param: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserFirstname',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserEmail(token: string, id: number, param: string) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserEmail',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async modifyACLResource(
		token: string,
		id: number,
		param: ACLResource
	) {
		return this.callBackendNoStatusCodeFilter(
			'/acl/resource/' + id,
			'PATCH',
			this.obj2ab({
				token,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async modifyACLUserDateDebut(
		token: string,
		id: number,
		param: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserDateDebut',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserDateExpire(
		token: string,
		id: number,
		param: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserDateExpire',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserIsActive(
		token: string,
		id: number,
		param: boolean
	) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserIsActive',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async modifyACLUserParent(token: string, id: number, param: number) {
		return this.callBackendNoStatusCodeFilter(
			'modifyACLUserParent',
			'POST',
			this.obj2ab({
				token,
				id,
				param,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async recoverUsernameFromEmailAdress(email: string) {
		const resetPasswordUrl =
			window.location.protocol +
			'//' +
			window.location.hostname +
			':' +
			window.location.port +
			'/new_password';
		return this.callBackendNoStatusCodeFilter(
			'reset',
			'POST',
			this.obj2ab({ email, resetPasswordUrl })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (
					typeof res === 'object' &&
					typeof res.message === 'string' &&
					res.username !== ''
				) {
					return;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async sendResetPasswordEmail(email: string, username: string) {
		const resetPasswordUrl =
			window.location.protocol +
			'//' +
			window.location.hostname +
			':' +
			window.location.port +
			'/password/new_password';
		return this.callBackendNoStatusCodeFilter(
			'reset',
			'POST',
			this.obj2ab({ username, email, resetPasswordUrl })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (
					typeof res === 'object' &&
					typeof res.message === 'string' &&
					res.message === 'USER NOT FOUND'
				) {
					throw new Error('User not found');
				}
				if (
					typeof res === 'object' &&
					typeof res.message === 'string' &&
					res.message === 'Matching email/username not found'
				) {
					throw new Error('User not found');
				}
				if (
					typeof res === 'object' &&
					typeof res.message === 'string'
				) {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async updatePasswordFromPrevious(
		oldPwd: string,
		newPwd: string,
		token: string,
		id: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'updatePwd',
			'POST',
			this.obj2ab({ oldPwd, newPwd, id, token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}

				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (
					typeof res === 'object' &&
					typeof res.message === 'string' &&
					res.message === 'password modified'
				) {
					return;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async updatePasswordFromEmail(
		newPwd: string,
		token: string,
		id: string
	) {
		return this.callBackendNoStatusCodeFilter(
			'updatePwd',
			'POST',
			this.obj2ab({ newPwd, id, token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}

				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (
					typeof res === 'object' &&
					typeof res.message === 'string' &&
					res.message === 'password modified'
				) {
					return;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async deleteUserResource(token: string, id: number) {
		return this.callBackendNoStatusCodeFilter(
			'deleteUserResource',
			'POST',
			this.obj2ab({ token, id })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async deleteACLResource(token: string, id: number) {
		return this.callBackendNoStatusCodeFilter(
			'resource/' + id,
			'DELETE',
			null,
			new Headers({
				Authorization: 'Bearer ' + token,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async updateUserResourceRights(
		token: string,
		resourceId: number,
		rightsIds: number[]
	) {
		return this.callBackendNoStatusCodeFilter(
			'updateUserResourceRights',
			'POST',
			this.obj2ab({
				token,
				resourceId,
				rightsIds,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async getAllACLUsername(token: string) {
		return this.callBackendNoStatusCodeFilter(
			'getAllACLUsernames',
			'POST',
			this.obj2ab({ token })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				if (res.status === 403) {
					throw new Error(
						'Error during the retrieving of the user. Please inform the support'
					);
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async isUserPresent(token: string, username: string) {
		return this.callBackendNoStatusCodeFilter(
			'isUserPresent',
			'POST',
			this.obj2ab({ token, username })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				if (res.status === 403) {
					throw new Error(
						'Error during the retrieving of the user. Please inform the support'
					);
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async impersonate(token: string, ID: number) {
		return this.callBackendNoStatusCodeFilter(
			'impersonate',
			'POST',
			this.obj2ab({ token, ID })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async setGroupChannels(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'ma/channels/group/' + groupID,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async setGroupChannelsMT(
		addedIDs: { mediaID: number; startDate: string; endDate: string }[],
		removedIDs: { mediaID: number; startDate: string; endDate: string }[],
		updatedIDs: { mediaID: number; startDate: string; endDate: string }[],
		userID: number,
		token: string
	) {
		let channelList = { addedIDs, removedIDs, updatedIDs };
		return this.callBackendNoStatusCodeFilter(
			'mt/channels/group/' + userID + '/' + token,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async setUserChannels(channelList: number[], userID: number) {
		return this.callBackendNoStatusCodeFilter(
			'ma/channels/user/' + userID,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async setGroupChannelsTPP(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'tpp/channels/group/' + groupID,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async setUserChannelsTPP(channelList: number[], userID: number) {
		return this.callBackendNoStatusCodeFilter(
			'tpp/channels/user/' + userID,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async setGroupChannelsSTT(channelList: number[], groupID: number) {
		return this.callBackendNoStatusCodeFilter(
			'stt/channels/group/' + groupID,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}
	public async setUserChannelsSTT(channelList: number[], userID: number) {
		return this.callBackendNoStatusCodeFilter(
			'stt/channels/user/' + userID,
			'POST',
			this.obj2ab({ channelList })
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	public async updateACLResource(
		token: string,
		id: number,
		aclResource: ACLResource
	) {
		return this.callBackendNoStatusCodeFilter(
			'resource/' + id,
			'PATCH',
			this.obj2ab({ aclResource }),
			new Headers({
				Authorization: 'Bearer ' + token,
			})
		)
			.then((res: any) => {
				if (res.status === 401) {
					throw new Error('Authentication failed');
				}
				let contentDisposition = res.headers.get('content-disposition');
				if (contentDisposition) {
					return {
						content: res.blob(),
						contentDisposition: contentDisposition,
					};
				}
				return res.arrayBuffer();
			})
			.then(this.ab2obj)
			.then((res: any) => {
				if (typeof res === 'object') {
					return res;
				}
				throw new Error('Invalid response from backend');
			});
	}

	// converts an object to an array buffer
	private obj2ab(obj: any): ArrayBuffer {
		return new TextEncoder().encode(JSON.stringify(obj));
	}

	// converts an array buffer to object
	private ab2obj(from: ArrayBuffer | IContentDisposition): any {
		const text = new TextDecoder().decode(
			new Uint8Array(from as ArrayBuffer)
		);

		// Si le texte ne commence pas par { ou [, ce n'est pas du JSON
		// On retourne directement le texte dans un objet
		if (!text.trim().startsWith('{') && !text.trim().startsWith('[')) {
			return { status: text };
		}

		return JSON.parse(text || '{}');
	}
}
